// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__Qeb2n","col":"Table_col__2zXaA","fulfillmentStatus":"Table_fulfillmentStatus__255RM","emailCol":"Table_emailCol__yp2CR"};